import { render, staticRenderFns } from "./commentDetail.vue?vue&type=template&id=202b24da&scoped=true"
import script from "./commentDetail.vue?vue&type=script&lang=js"
export * from "./commentDetail.vue?vue&type=script&lang=js"
import style0 from "./commentDetail.vue?vue&type=style&index=0&id=202b24da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b24da",
  null
  
)

export default component.exports